import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import { FilterChipVariant } from "app/pages/sales-intelligence/common-components/filters-panel/types/commonEnums";
import { INDUSTRIES_CODE_NAMES } from "app/pages/sales-intelligence/domain/industry/types/codes";
import type { FilterValueLifecycleStatus } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";

import type { IIndustryChipItem, IndustryChipItemType } from "../types";

function createIndustryChipItems(
    items: readonly string[],
    type: IndustryChipItemType,
    getLifecycleStatus?: (value: Partial<string>) => FilterValueLifecycleStatus,
): IIndustryChipItem[] {
    return items.map((item) => {
        let text = "";
        let chipProps: Partial<ChipItem> = {};

        if (type === "industry") {
            const names = item.split("~");

            text = names[1] || names[0];
            chipProps = {
                variant: FilterChipVariant.Icon,
                iconName: "group-industry",
            };
        } else {
            text = `${INDUSTRIES_CODE_NAMES[type]}: ${item}`;
        }

        return {
            type,
            id: item,
            text,
            chipStatus: getLifecycleStatus?.(item),
            ...chipProps,
        };
    });
}

export default createIndustryChipItems;
